import { useContext } from 'react';
import { useBusinessCollectionMenuItemsType } from '../../../../../../Utils/ObjektVyUtils';
import { FakturaattestWrapperContext } from '../Contexts/FakturaattestWrapperContext';

export const useFakturaattestBusinessCollectionMenuItems: useBusinessCollectionMenuItemsType =
  () => {
    const fakturaattestContext = useContext(FakturaattestWrapperContext);

    return [
      {
        id: 'Hantera frånvaro',
        caption: 'Hantera frånvaro',
        onClick: () => {
          fakturaattestContext.setOpenReservDialog(true);
        },
        iconType: 'account_card_details',
      },
    ];
  };
